import {
  parseAsString,
  createSearchParamsCache,
  parseAsArrayOf,
  parseAsInteger,
} from "nuqs/server";

export const searchParams = {
  // Generic query
  name: parseAsString.withDefault(""),

  // German keys (canonical)
  marke: parseAsArrayOf(parseAsString).withDefault([]),
  standort: parseAsArrayOf(parseAsString).withDefault([]),
  abteilung: parseAsArrayOf(parseAsString).withDefault([]),
  kategorie: parseAsArrayOf(parseAsString).withDefault([]),
  tenantStandortReset: parseAsString.withDefault(""),
  // Pagination (page number, 1-based)
  seite: parseAsInteger.withDefault(1),
};

// Export the cache function per nuqs docs
export const searchParamsCache = createSearchParamsCache(searchParams);

// Keys that are defined as array-of-strings parsers
export const arraySearchParams = {
  marke: searchParams.marke,
  standort: searchParams.standort,
  abteilung: searchParams.abteilung,
  // Bind UI key "kategorie" to its dedicated parser
  kategorie: searchParams.kategorie,
};

export type ArraySearchParamKey = keyof typeof arraySearchParams;

// Single string search params
export const stringSearchParams = {
  name: searchParams.name,
};

export type StringSearchParamKey = keyof typeof stringSearchParams;
